import {DreamEmployerClass, DreamEmployerLegacyClass} from '../../../types/DreamEmployerTypes';

export const isLegacyDreamEmployer = (
  data: DreamEmployerClass | DreamEmployerLegacyClass
): data is DreamEmployerLegacyClass => {
  return (data as DreamEmployerLegacyClass)?.type === 'dream_employer_legacy';
};
